import React from "react";
import { Box } from "@mui/material";
import TableChartRoundedIcon from "@mui/icons-material/TableChartRounded";

import { INTEGRATIONS_CONFIG } from "../../../shared/integrations";

const featuredIntegrationTitles = ["SGP", "HubSoft", "IXC Soft", "Asaas"];
const rotationIntervalSeconds = 1.8;

const featuredIntegrations = [
  ...featuredIntegrationTitles
    .map((title) => INTEGRATIONS_CONFIG.find((integration) => integration.title === title))
    .filter(Boolean),
  {
    title: "Google Planilhas",
    Icon: TableChartRoundedIcon,
  },
];

const rotatingIntegrations = INTEGRATIONS_CONFIG.filter(
  (integration) => !featuredIntegrationTitles.includes(integration.title),
);

function IntegrationLogo({ integration, sx }) {
  if (integration.Icon) {
    const Icon = integration.Icon;

    return (
      <Box
        sx={{
          display: "grid",
          placeItems: "center",
          width: 28,
          height: 28,
          flex: "0 0 28px",
          borderRadius: "50%",
          overflow: "hidden",
          opacity: 0.96,
          ...sx,
        }}
      >
        <Icon sx={{ width: 21, height: 28, color: "#188038" }} />
      </Box>
    );
  }

  return (
    <Box
      component="img"
      src={integration.icon}
      alt=""
      sx={{
        width: 28,
        height: 28,
        flex: "0 0 28px",
        display: "block",
        borderRadius: "50%",
        overflow: "hidden",
        objectFit: "contain",
        opacity: 0.96,
        ...sx,
      }}
    />
  );
}

function AnimatedIntegrationLogo() {
  const duration = rotatingIntegrations.length * rotationIntervalSeconds;

  return (
    <Box
      sx={{
        position: "relative",
        display: "grid",
        placeItems: "center",
        width: 28,
        height: 28,
        flex: "0 0 28px",
        borderRadius: "50%",
        bgcolor: "#FFFFFF",
        boxShadow: "0 8px 20px rgba(15, 23, 42, 0.18)",
        overflow: "hidden",
        isolation: "isolate",
        "&::after": {
          content: '""',
          position: "absolute",
          inset: 0,
          borderRadius: "inherit",
          border: "1px solid rgba(255, 255, 255, 0.9)",
          pointerEvents: "none",
        },
        "@keyframes authIntegrationLogoCycle": {
          "0%": {
            opacity: 0,
            transform: "scale(0.72) rotate(-10deg)",
          },
          "2%, 8%": {
            opacity: 1,
            transform: "scale(1) rotate(0deg)",
          },
          "10%, 100%": {
            opacity: 0,
            transform: "scale(0.72) rotate(10deg)",
          },
        },
      }}
    >
      {rotatingIntegrations.map((integration, index) => (
        <IntegrationLogo
          key={integration.id}
          integration={integration}
          sx={{
            position: "absolute",
            inset: 0,
            width: "100%",
            height: "100%",
            opacity: 0,
            animation: `authIntegrationLogoCycle ${duration}s linear infinite`,
            animationDelay: `${index * rotationIntervalSeconds}s`,
          }}
        />
      ))}
    </Box>
  );
}

export default function AuthIntegrationStrip() {
  return (
    <Box
      aria-hidden="true"
      sx={{
        display: "flex",
        alignItems: "center",
        gap: { md: 1.5, lg: 2 },
        mt: { md: 3, lg: 3.5 },
        "@media (max-height: 760px)": {
          mt: 2.5,
        },
      }}
    >
      {featuredIntegrations.map((integration) => (
        <IntegrationLogo key={integration.title} integration={integration} />
      ))}

      <AnimatedIntegrationLogo />
    </Box>
  );
}
